// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

// EQUIPEMENT TYPE UUID
export const MONITOR_EQUIPMENT_TYPE_ID = '8c7d5848-e19d-442c-ab49-5a4177280d1f';
export const LED_EQUIPMENT_TYPE_ID = 'f4a52881-c121-446d-b735-8ce7f59266d3';
export const CAMERA_EQUIPMENT_TYPE_ID = '4360dd55-0b15-4a99-89a1-d99250c74e70';
export const NDI_EQUIPMENT_TYPE_ID = '103bc382-fd6e-4f08-bd89-845f5bfe1f19';
export const LOWER_THIRD_EQUIPMENT_TYPE_ID = '2d435282-40ad-436f-83f2-27ab7144dd1b';
export const LIGHT_EQUIPMENT_TYPE_ID = 'a5c2fcb0-d8b2-4bb1-a466-e9aa9f08c075';
export const PTZ_CAMERA_EQUIPMENT_TYPE_ID = '82aa2778-9b9b-47ff-b97d-ea260334f5f6';
export const ELEVATION_UNIT_EQUIPMENT_TYPE_ID = '7a1ec1ba-e9e0-4eb5-b04e-e3aad4cb2d66';
export const DUAL_STACK_ELEVATION_UNIT_EQUIPMENT_TYPE_ID = '403a7644-b10a-4671-a183-3a08f91ffdf4';
export const MORAIL_CARRIAGE_EQUIPMENT_TYPE_ID = '70e607a9-77be-4cd1-8bdf-6b04dfe6c64c';
export const VISUALISATION_STRIP_EQUIPMENT_TYPE_ID = '589a34e8-7a83-4a2f-854b-229cef218c32';
export const SHOT_CONSOLE_EQUIPMENT_TYPE_ID = '4328411f-bc84-4b4a-a28f-3513acecc000';
export const STREAM_MONITOR_EQUIPMENT_TYPE_ID = '0b62acbb-dd25-44f7-a4b9-82943b076aca';

// EQUIPMENT GROUP TYPE UUID
export const CONTROLLABLE_STUDIO_GROUP_TYPE_ID = 'efff423b-37c1-47b7-b851-114649fcab53';
export const CAMERAS_GROUP_TYPE_ID = '3bcd8417-bd04-4d85-866b-6f78bdfc5bba';
export const ELEVATED_CAMERA_GROUP_TYPE_ID = '69be7464-8ccb-41e8-8c9a-a05a148b9c75';
export const MORAIL_GROUP_TYPE_ID = '7ec405be-3f80-4abc-9e14-ad8c7f636f48';
export const DUAL_STACK_MORAIL_GROUP_TYPE_ID = 'c4472fa4-f9e1-4a13-b4de-3395963218ad';
export const CONTROL_ROOM_GROUP_TYPE_ID = '5f4384fd-be61-4db0-b6ed-5d27f6fbfbf5';
export const STREAMS_MONITORS_GROUP_TYPE_ID = '9fffb3e8-8387-4083-95c7-1654f0e22dc2';

// MONITOR UUID
export const MONITOR_EQUP_EPROP_ID = 'c21e1709-3720-4002-b8e7-e47d47ddc88a';
export const MONITOR_SCENE_BLK_ESET_ID = 'f97490e0-0acd-469e-b178-fb91272623b0';
export const MONITOR_CAMERA_BLK_ESET_ID = '0b007042-6c77-46b3-ba97-11d98c31c09c';
export const MONITOR_COMPOSITE_BLK_ESET_ID = '021ad27b-1464-473c-9b9b-06e82ca48323';

// CAMERA UUID
export const CAMERA_EQUP_EPROP_ID = '29c15b99-2c29-4801-bf0a-047c8012a4c7';

// LED UUID
export const LED_SCENE_BLK_ESET_ID = '6ef26021-838d-4b52-bef7-08efb110d0a2';
export const LED_NDI_BLK_ESET_ID = 'a431f7ad-4ca6-4c5a-a026-90a81e2dea84';

// COMPOSITE MODE UUID
export const XR_COMPOSITE_MODE = '42c71c05-d988-4199-bdc9-4fbf568286fa';
export const VIDEO_ONLY_COMPOSITE_MODE = 'a59b6291-807e-4826-9fcd-b37153ff0ec7';
export const NO_COMPOSITE_MODE = 'a53d3ac0-43ea-4f8a-abf4-05ef791256a2';

// LOWER THIRD BLK_ESET_ID
export const TITLE_BLK_ESET_ID = 'a4b2aa34-2f21-456d-8b75-b7fd17d30d93';
export const SUBTITLE_BLK_ESET_ID = 'dff0193c-4f01-418e-a4e8-7c5db7b9fe10';

// LIGTHING EQUIP BLK_ESET_ID
export const LIGHTING_PRESET_BLK_ESET_ID = 'dc1e945d-3609-45e8-bb90-c0c30d5c4b36';
export const LIGHTING_PRESET_LABEL_BLK_ESET_ID = 'eedf0704-50e3-47df-a1d3-08145c839cf1';

// SCENE_DIMEMSION
export const types = ['2D', '2.5D', 'Scan', '3D'];

// get the show_quipment_uuid
export const getShowEquipUuid = (show, equip) => {
  if (!show || !equip) {
    return null;
  }

  const { equipmentUuid, equipPropUuid, equipmentVal } = equip;
  const matchingEquipments =
    show.show_equipment?.filter(item => item?.equip_type_uuid === equipmentUuid) ?? [];
  if (matchingEquipments.length === 0) {
    return null;
  }
  if (matchingEquipments.length === 1) {
    return matchingEquipments[0]?.show_equip_uuid ?? null;
  }

  for (const equipment of matchingEquipments) {
    const properties = equipment.equipment_properties ?? [];
    for (const prop of properties) {
      if (prop?.eprop_uuid !== equipPropUuid) {
        continue;
      }
      const hasMatchingValue = (prop.show_eprop_val ?? []).some(
        val => val?.value === String(equipmentVal)
      );
      if (hasMatchingValue) {
        return equipment.show_equip_uuid ?? null;
      }
    }
  }

  return null;
};
